/* ==========================================================================
   Announcement bar
   Swiper-backed rotation with a progress line, paused on hover, on keyboard
   focus and while the tab is hidden. Reduced-motion visitors get a static bar.
   Degrades safely: if Swiper is missing the first message still renders.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function frameOf(el) {
    return el.closest ? el.closest('[data-purrz-bar]') : null;
  }

  function startProgress(frame) {
    if (!frame || frame.dataset.autoplay !== 'true' || REDUCED.matches) return;
    var line = frame.querySelector('.s-announcement-bar__progress i');
    if (!line) return;
    frame.classList.remove('is-running');
    // Force a reflow so the animation restarts on every slide change.
    void line.offsetWidth;
    frame.classList.add('is-running');
  }

  function setPaused(frame, paused) {
    if (!frame) return;
    frame.classList.toggle('is-paused', !!paused);
    var bar = frame.querySelector('s-announcement-bar');
    var swiper = bar && bar.swiper;
    if (!swiper || !swiper.autoplay) return;
    try {
      if (paused) swiper.autoplay.stop();
      else swiper.autoplay.start();
    } catch (err) {
      /* older Swiper builds without autoplay control */
    }
  }

  function initBar(bar) {
    if (bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    var frame = frameOf(bar);
    var slides = bar.querySelectorAll('.s-announcement-bar__item');
    var autoplayWanted = frame ? frame.dataset.autoplay === 'true' : true;
    var delay = frame ? parseInt(frame.dataset.delay, 10) || 6000 : 6000;
    var canAutoplay = autoplayWanted && !REDUCED.matches && slides.length > 1;

    if (frame) frame.style.setProperty('--ab-delay', delay + 'ms');

    if (typeof window.Swiper !== 'function') return;

    var options = {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      loop: slides.length > 1,
      allowTouchMove: slides.length > 1,
      a11y: { enabled: false },
      on: {
        init: function () {
          startProgress(frame);
        },
        slideChange: function () {
          startProgress(frame);
        }
      }
    };

    if (canAutoplay) {
      options.autoplay = { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: false };
    }

    bar.swiper = new window.Swiper(bar, options);

    if (!canAutoplay) return;

    var pause = function () { setPaused(frame, true); };
    var resume = function () { setPaused(frame, false); };

    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', resume);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', resume);

    if (frame) {
      var pin = frame.querySelector('.s-announcement-bar__pin');
      if (pin) {
        pin.addEventListener('mouseenter', pause);
        pin.addEventListener('mouseleave', resume);
        pin.addEventListener('focus', pause);
        pin.addEventListener('blur', resume);
      }
    }

    document.addEventListener('visibilitychange', function () {
      setPaused(frame, document.hidden);
    });
  }

  if (!customElements.get('s-announcement-bar')) {
    customElements.define(
      's-announcement-bar',
      class SectionAnnouncementBar extends HTMLElement {
        connectedCallback() {
          // Swiper may load after the element upgrades; retry briefly.
          var self = this;
          var tries = 0;
          var attempt = function () {
            if (typeof window.Swiper === 'function' || tries > 20) {
              initBar(self);
              return;
            }
            tries += 1;
            window.setTimeout(attempt, 100);
          };
          attempt();
        }

        disconnectedCallback() {
          if (this.swiper && typeof this.swiper.destroy === 'function') {
            try { this.swiper.destroy(true, true); } catch (err) { /* noop */ }
          }
          delete this.dataset.ready;
        }
      }
    );
  }
})();
